import React, {useEffect, useRef, useState} from 'react';
import SectionTitle from '../../components/site/SectionTitle';
import SplitShowcase from '../../components/site/SplitShowcase';
import PocTradingView from '../../components/site/PocTradingView';
import {useWaitlist} from '../../components/site/WaitlistModal';
import {useSiteContent} from './siteContent';
import {useHeroCanvas} from '../../hooks/useHeroCanvas';
import DisabledPocNotice from '../../components/site/DisabledPocNotice';
import {systemConfigService} from '../../services/systemConfigService';
import styles from './SitePages.module.css';

const AssistTradingPocPage: React.FC = () => {
    const {assistPocPage} = useSiteContent();
    const {openWaitlist} = useWaitlist();
    const heroSectionRef = useRef<HTMLElement>(null);
    const heroCanvasRef = useRef<HTMLCanvasElement>(null);
    const [enabled, setEnabled] = useState<boolean | null>(null);

    useEffect(() => {
        loadConfig();
    }, []);

    useHeroCanvas(heroSectionRef, heroCanvasRef);

    const loadConfig = async () => {
        try {
            const response = await systemConfigService.getPocDisplayConfig();
            if ('0' === response.data.code) {
                setEnabled(response.data.data.assistTradingEnabled);
            } else {
                setEnabled(false);
            }
        } catch (error) {
            console.error('加载POC配置失败:', error);
            setEnabled(false);
        }
    };

    if (enabled === null) {
        return null;
    }

    if (!enabled) {
        return <DisabledPocNotice/>;
    }

    return (
        <div className={styles.page}>
            <section ref={heroSectionRef} className={`${styles.section} ${styles.heroSectionWrapper}`}>
                <canvas ref={heroCanvasRef} className={styles.heroSectionCanvas}/>
                <div style={{position: 'relative', zIndex: 1}}>
                    <SectionTitle
                        description={assistPocPage.sectionTitles.demo.description}
                        eyebrow={assistPocPage.sectionTitles.demo.eyebrow}
                        title={assistPocPage.sectionTitles.demo.title}
                    />
                    <div className={`site-section ${styles.showcaseConstellation}`} data-hover-stop="constellation">
                        <PocTradingView/>
                    </div>
                </div>
            </section>

            <section className={styles.section}>
                <SectionTitle
                    description={assistPocPage.sectionTitles.stories.description}
                    eyebrow={assistPocPage.sectionTitles.stories.eyebrow}
                    title={assistPocPage.sectionTitles.stories.title}
                />
                <div className={`${styles.storyStack} site-section`}>
                    {assistPocPage.stories.map((story, index) => (
                        <SplitShowcase block={story} key={story.title} reverse={index % 2 === 1}/>
                    ))}
                </div>
            </section>

            <section className={styles.section}>
                <article className={`site-card ${styles.ctaPanel}`}>
                    <div>
                        <span className="site-eyebrow">{assistPocPage.hero.panelLabel}</span>
                        <h3>{assistPocPage.hero.panelTitle}</h3>
                        <p>{assistPocPage.hero.panelDescription}</p>
                    </div>
                    <div className={styles.ctaActions}>
                        <button className={styles.ctaButton} type="button" onClick={openWaitlist}>
                            {assistPocPage.sectionTitles.cta.primaryLabel}
                        </button>
                    </div>
                </article>
            </section>
        </div>
    );
};

export default AssistTradingPocPage;
